import { Box, Typography } from '@mui/material';
import React from 'react';

interface AutocompleteOptionProps extends React.HTMLAttributes<HTMLLIElement> {
  label: string;
  helperText?: string;
}
const _AutocompleteOption: React.FC<AutocompleteOptionProps> = ({ label, helperText, ...props }) => {
  return (
    <Box component="li" {...props} sx={{ flexDirection: 'column', alignItems: 'flex-start!important' }}>
      <Typography variant="medium">{label}</Typography>
      {helperText && (
        <Typography variant="small" sx={{ mt: 0.5 }} fontWeight="Medium" color="secondary">
          {helperText}
        </Typography>
      )}
    </Box>
  );
};
export const AutocompleteOption = React.memo(_AutocompleteOption);
